import { useLayoutEffect } from 'react'
import { useLocation } from 'react-router-dom'

import { useAuth } from '../auth/AuthProvider'
import { useAnalyticsConsent } from '../lib/analyticsConsent'
import { isMetrikaPublicPage, stopMetrika, trackMetrikaPage } from '../lib/metrika'

// Outside Suspense so lazy pages and both responsive cabinets share one router observer.
export default function Metrika() {
  const location = useLocation()
  const { authenticated } = useAuth()
  const consent = useAnalyticsConsent()
  const publicPage = isMetrikaPublicPage(location.pathname, authenticated)

  useLayoutEffect(() => {
    // Also covers portals into document.body. Layout effects run before mutation observers,
    // so the replay cannot see a newly mounted cabinet between SPA routes.
    document.body.classList.toggle('ym-hide-content', !publicPage)
    document.body.classList.toggle('ym-disable-clickmap', !publicPage)
    if (consent !== 'granted') {
      stopMetrika()
      return
    }
    trackMetrikaPage(window.location.origin + location.pathname + location.search, location.key, publicPage)
  }, [consent, location.key, location.pathname, location.search, publicPage])

  return null
}
